import Constants from 'expo-constants';

import { logger as LOG } from '../../utils';

// ────────────────────────────────────────────────────────────────────────────────

export const reCaptchaLogger = LOG.extend('RECAPTCHA');

export function checkIfRecaptchaEnabled() {
  return Constants.expoConfig?.extra?.APP_ENV === 'production';
}
